const productsList = [
    {
        title: 'lbl_sports',
        enterPoint: '#Sports/s=0',
        imagePath: 'products/Sports.png',
    },
    {
        title: 'lbl_VirtualSports',
        enterPoint: '#Sports/s=180',
        imagePath: 'products/VirtualSports.png',
    },
    {
        title: 'lbl_Esports',
        enterPoint: '#Sports/s=43',
        imagePath: 'products/E-Sports.png',
    },
    {
        title: 'lbl_NumberGame',
        enterPoint: '#Sports/s=161',
        imagePath: 'products/NumberGame.png',
    },
    {
        title: 'lbl_Gaming',
        enterPoint: '',
        imagePath: 'products/Gaming.png',
    },
    {
        title: 'lbl_RNGKeno',
        enterPoint: '',
        imagePath: 'products/RNGKeno.png',
    },
    {
        title: 'lbl_Sabagames',
        enterPoint: '',
        imagePath: 'products/Saba.club.png',
    },
];

export default productsList;
